export default {env: 'production', desc: '构建时间: 2023-08-04 00:28:10 版本: f454c4d 时间: 2023-08-01 13:41:28 +0800 作者:ZAQ 注释:remove useless code', app_name: 'knowlege'}
